// @flow
import React from "react";
import { localize } from "redux-i18n";
import { GSGrid, View } from "@components";
import { formatDateTime } from "@transformers/date";

type Props = $Exact<{
  data: *,
  ...PropsFromLocalize,
}>;

export const ReferralAbsenceHistoryTable = ({ data, t }: Props) => (
  <View name="ReferralAbsenceHistoryTable" gap={3}>
    <h5>{t("ABSENCE_HISTORY_LAST_10_ABSENCES")}</h5>
    <GSGrid
      rows={data}
      rowKeyGetter={row => row.id}
      columns={[
        {
          name: t("ABSENCE_ID"),
          key: "id",
        },
        {
          name: t("START_DATE"),
          renderCell: ({ row }: *) => formatDateTime(row.startsAt),
          key: "startsAt",
          width: 150,
        },
        {
          name: t("RTW_DATE"),
          renderCell: ({ row }: *) => formatDateTime(row.rtwAt),
          key: "rtwAt",
          width: 150,
        },
        {
          name: t("WDL"),
          renderCell: ({ row }: *) => row.workingDaysLost,
          key: "workingDaysLost",
        },
        {
          name: t("REASON"),
          renderCell: ({ row }: *) => row.absenceReason && row.absenceReason.name,
          key: "reason",
        },
        {
          name: t("STATUS"),
          renderCell: ({ row }: *) => t(row.status),
          key: "status",
          width: 100,
        },
        {
          name: t("WORK_RELATED_HEADER"),
          renderCell: ({ row }: *) => (row.isWorkRelated ? t("YES") : t("NO")),
          key: "isWorkRelated",
          width: 100,
        },
      ]}
    />
  </View>
);

export default localize()(ReferralAbsenceHistoryTable);
